module.exports = __webpack_public_path__ + "img/alex.19dc0bbe.svg";